module.exports = __webpack_public_path__ + "media/images/footer_logo_pc-d3c4b340843d5c8554bf2207bae656b5.svg";